<template>
  <div class="p-grid">
    <Toast />

    <div class="p-col-12">
      <Breadcrumb :home="breadcrumbHome" :model="breadcrumbItems" />
    </div>

    <div class="p-col-12">
      <div class="card" v-if="loadingIndicator">
        <p>Loading, please wait . . .</p>
        <ProgressBar mode="indeterminate" style="height: .5em" />
      </div>

      <div class="card">
        <div class="p-d-flex p-jc-between">
          <div><h3>Audit Trail</h3></div>
        </div>

        <Message v-for="(msg, index) in messages" :severity="msg.severity" :key="index" :life="5000" :sticky="false">{{msg.content}}</Message>

        <Toolbar class="p-mb-4">
          <template #end>
            <Button label="Search" icon="pi pi-search" class="p-button-primary p-mr-2" @click="toggleSearch()"/>
            <Button icon="pi pi-refresh" class="p-button-help" @click="refreshList()" />
          </template>
        </Toolbar>

        <div class="card" v-if="displaySearch">
          <h5>Audit Trail Search</h5>
          <div class="p-field p-grid">
            <label class="p-col-12 p-mb-2 p-sm-12 p-md-2 p-mb-md-0">Start Date</label>
            <div class="p-col-12 p-sm-12 p-md-10">
              <Calendar :showIcon="true" :showButtonBar="true" v-model="searchData.startDate.value" dateFormat="yy-mm-dd" />
            </div>
          </div>
          <div class="p-field p-grid">
            <label class="p-col-12 p-mb-2 p-sm-12 p-md-2 p-mb-md-0">End Date</label>
            <div class="p-col-12 p-sm-12 p-md-10">
              <Calendar :showIcon="true" :showButtonBar="true" v-model="searchData.endDate.value" dateFormat="yy-mm-dd" />
            </div>
          </div>
          <div class="p-field p-grid">
            <label class="p-col-12 p-mb-2 p-sm-12 p-md-2 p-mb-md-0">Vardata</label>
            <div class="p-col-12 p-sm-12 p-md-10">
              <InputText v-model="searchData.vardata.value" />
            </div>
          </div>
          <Button label="Search" style="margin-right: .5em" @click="search()"/>
          <br />
        </div>

        <DataTable :value="auditTrails" :paginator="true" class="p-datatable-customers" :rows="10" dataKey="id" :rowHover="true" :filters="filters" :loading="tableLoading" responsiveLayout="scroll" :rowsPerPageOptions="[10,25,50,100]">
          <template #header>
            <div class="table-header">
              List of Audit Trails
              <span class="p-input-icon-left">
                <i class="pi pi-search" />
                <InputText v-model="filters['global'].value" placeholder="Fine Search" />
              </span>
            </div>
          </template>
          <template #empty>
            No audit trail found.
          </template>
          <template #loading>
            Loading audit trail list. Please wait.
          </template>
          <Column header="ID" field="id" sortable />
          <Column header="User ID" field="user_id" sortable />
          <Column header="Request Time" field="req_time" sortable />
          <Column header="Category" field="category" sortable />
          <Column headerStyle="width: 20rem; text-align: center" bodyStyle="text-align: center; overflow: visible;">
            <template #body="auditTrail" >
              <Button v-if="permited(['auditTrails.*', 'auditTrails.view'])" icon="pi pi-eye" class="p-button-rounded p-button-info p-mr-2" @click="viewAuditTrail(auditTrail.data.id)" />
            </template>
          </Column>
        </DataTable>

        <Dialog :visible.sync="auditDialog" class="p-fluid" header="Audit Trail Details" :style="{width: '70vw'}" :modal="true">
          <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-6">
              <label style="font-weight: bold">ID</label>
              <div style="color:black; border-bottom:2px solid #d4dcdc; line-height: 2; margin-bottom: 30px; margin-top: 0;">{{ auditData.id }}</div>
            </div>
            <div class="p-field p-col-12 p-md-6">
              <label style="font-weight: bold">User ID</label>
              <div style="color:black; border-bottom:2px solid #d4dcdc; line-height: 2; margin-bottom: 30px; margin-top: 0;">{{ auditData.user_id }}</div>
            </div>
            <div class="p-field p-col-12 p-md-6">
              <label style="font-weight: bold">Request Time</label>
              <div style="color:black; border-bottom:2px solid #d4dcdc; line-height: 2; margin-bottom: 30px; margin-top: 0;">{{ auditData.req_time }}</div>
            </div>
            <div class="p-field p-col-12 p-md-6">
              <label style="font-weight: bold">Category</label>
              <div style="color:black; border-bottom:2px solid #d4dcdc; line-height: 2; margin-bottom: 30px; margin-top: 0;">{{ auditData.category }}</div>
            </div>
            <div class="p-field p-col-12">
              <label style="font-weight: bold">Vardata</label>
              <div style="color:black; border-bottom:2px solid #d4dcdc; line-height: 2; margin-bottom: 30px; margin-top: 0; white-space: pre-wrap;">{{ auditData.vardata }}</div>
            </div>
          </div>
        </Dialog>
      </div>
    </div>
  </div>
</template>

<script>
import { getAuditTrails, getAuditTrail, searchAuditTrails } from '@/api/auditTrail'

export default {
  name: "AuditTrail",

  data() {
    return {
      breadcrumbHome: { icon: 'pi pi-home', to: { name: 'dashboard' } },
      breadcrumbItems: [
        { label:'Audit Trail', to: this.$route.path }
      ],
      messages: [],
      loadingIndicator: false,

      auditTrails: [],
      tableLoading: true,
      filters: {
        'global': { value: null },
      },

      auditData: {},
      auditDialog: false,

      isListSearch: false,
      displaySearch: false,
      searchData: {
        startDate: { value: '', errMsg: null },
        endDate: { value: '', errMsg: null },
        vardata: { value: '', errMsg: null }
      }
    }
  },

  created() {
    let flashMessage = this.$session.flash.get("flash-message")
    if(flashMessage) {
      this.messages.push({ severity: this.$session.flash.get("flash-class"), content: flashMessage })
    }

    this.getAuditTrailList()
  },

  methods: {
    refreshList() {
      if(this.isListSearch) {
        this.search()
      } else {
        this.getAuditTrailList()
      }
    },

    getAuditTrailList() {
      this.tableLoading = true

      try {
        getAuditTrails()
          .then((res) => {
            if (res.data.total == 0) {
              this.isLoadNull = true
            }

            // this.rows = res.data.total
            // this.perPage = res.data.per_page
            // this.row_from = res.data.from

            this.auditTrails = res.data.data
          })
          .catch(() => {
            this.messages.push({ severity: 'error', content: "Failed to get audit trail list" })
          })
          .finally(() => this.tableLoading = false)
      } catch (e) {
        console.error(e)
        this.messages.push({ severity: 'error', content: "Failed to get audit trail list" })
      }
    },

    search() {
      this.isLoadNull = false
      this.tableLoading = true

      try {
        let reqObj = {}

        if(this.searchData.startDate.value) {
          reqObj.start_date = this.searchData.startDate.value
        }

        if(this.searchData.endDate.value) {
          reqObj.end_date = this.searchData.endDate.value
        }

        if(this.searchData.vardata.value) {
          reqObj.vardata = this.searchData.vardata.value
        }

        searchAuditTrails(reqObj)
          .then((res) => {
            this.isListSearch = true

            if (res.data.total == 0) {
              this.isLoadNull = true
            }

            // this.rows = res.data.total
            // this.perPage = res.data.per_page
            // this.row_from = res.data.from

            this.auditTrails = res.data.data
          })
          .catch(() => {
            this.messages.push({ severity: 'error', content: "Failed to search audit trail" })
          })
          .finally(() => this.tableLoading = false)
      } catch (e) {
        console.error(e)
        this.messages.push({ severity: 'error', content: "Failed to search audit trail" })
      }
    },

    viewAuditTrail(id) {
      this.loadingIndicator = true

      try {
        getAuditTrail(id)
          .then((res) => {
            if(res.data.status) {
              const data = res.data.data

              this.auditData = data
              this.auditDialog = true
            } else {
              this.$toast.add({severity:'error', summary: 'Error', detail: res.data.message, life: 5000})
            }
          })
          .catch(() => {
            this.messages.push({ severity: 'error', content: "Failed to get audit trail detail" })
          })
          .finally(() => this.loadingIndicator = false)
      } catch (e) {
        console.error(e)
        this.messages.push({ severity: 'error', content: "Failed to get audit trail detail" })
      }
    },

    toggleSearch() {
      this.displaySearch = !this.displaySearch
    },

    permited(permissions) {
      return this.$parent.permited(permissions)
    }
  }
}
</script>

<style scoped lang="scss">
.p-datatable .p-column-filter {
  display: none;
}

.table-header {
  display: flex;
  justify-content: space-between;
}

/deep/ .p-datatable.p-datatable-customers {
  .p-datatable-header {
    padding: 1rem;
    text-align: left;
    font-size: 1.5rem;
  }

  .p-paginator {
    padding: 1rem;
  }

  .p-datatable-thead > tr > th {
    text-align: left;
  }

  .p-datatable-tbody > tr > td {
    cursor: auto;
  }

  .p-dropdown-label:not(.p-placeholder) {
    text-transform: uppercase;
  }
}

/* Responsive */
.p-datatable-customers .p-datatable-tbody > tr > td .p-column-title {
  display: none;
}

@media screen and (max-width: 960px) {
  /deep/ .p-datatable {
    &.p-datatable-customers {
      .p-datatable-thead > tr > th,
      .p-datatable-tfoot > tr > td {
        display: none !important;
      }

      .p-datatable-tbody > tr {
        border-bottom: 1px solid var(--layer-2);

        > td {
          text-align: left;
          display: block;
          border: 0 none !important;
          width: 100% !important;
          float: left;
          clear: left;
          border: 0 none;

          .p-column-title {
            padding: .4rem;
            min-width: 30%;
            display: inline-block;
            margin: -.4rem 1rem -.4rem -.4rem;
            font-weight: bold;
          }

          .p-progressbar {
            margin-top: .5rem;
          }
        }
      }

      // .table-header {
      // 	i.pi-search {
      // 		margin-top: 1rem;
      // 	}
      // }
    }
  }
}
</style>